export interface UserState {
    user: any;
    isAuth: boolean,
    loading: boolean;
    message: string;
    profile: any;
    status: any;
    allUsers: any;
    allRoles: string[];
}

export enum UserActionType {
    START_REQUEST = "START_REQUEST",
    USER_LOADED = "USER_LOADED",
    PROFILE_LOADED = "PROFILE_LOADED",
    STATUS_LOADED = "STATUS_LOADED",
    LOGGED_IN = "LOGGED_IN",
    LOGGED_OUT = "LOGGED_OUT",
    FINISH_REQUEST = "FINISH_REQUEST",
    USER_REGISTERED = "USER_REGISTERED",
    GET_ALL_USERS = "GET_ALL_USERS",
    GET_ALL_ROLES = "GET_ALL_ROLES",
}